import React, { useEffect } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/leadstageageings_enum";
import SingleView from "../../components/common/SingleView";
import { useSingleLeadstageageing } from "../../shared/hooks/UseLeadstageageing";
const ViewLeadstageageing = ({ match }) => {
  const [data] = useSingleLeadstageageing(match.params.id);
  const { loading, leadstageageing } = data;
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!loading ? (
          leadstageageing && (
            <SingleView
              data={leadstageageing}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={leadstageageing.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewLeadstageageing;
                    